export default {
  STUDENT: 1,
  THIRD_PARTY: 2,
};
